// LLM pricing rates (USD per 1M tokens)
export const PRICING_RATES = {
  "openai/gpt-5.2": {
    input: 1.75,
    output: 14.0,
    cached: 0.175,
  },
  "openai/responses/gpt-5.2": {
    input: 1.75,
    output: 14.0,
    cached: 0.175,
  },
  "vertex_ai/claude-opus-4-5@20251101": {
    input: 5.00,
    output: 25.00,
    cached: 0.50,
  },
  "vertex_ai/claude-sonnet-4-5@20250929": {
    input: 3.00,
    output: 15.00,
    cached: 0.30,
  },
  "vertex_ai/claude-haiku-4-5@20250929": {
    input: 1.00,
    output: 5.00,
    cached: 0.10,
  },
  "gemini-3-pro-preview": {
    input: 2.00,
    output: 12.00,
    cached: 0.20,
  },
  "gemini-3-flash-preview": {
    input: 0.5,
    output: 3.00,
    cached: 0.05,
  },
} as const;

export type ModelName = keyof typeof PRICING_RATES;
